// models
import { EmployeeModel } from '@/models/config'
import { PropOptionRadio } from '@/models'

// utils
import { dateLibs } from '@/utils'

 const initConcubine = {
    name: '',
    last_name: '',
    document_type: 0,
    document_number: '',
    phone_number: '',
    date_birth: dateLibs.today()
}

const employeeInitConst: EmployeeModel = {
    uid: 0,
    email: '',
    name: '',
    last_name: '',
    mothers_last_name: '',
    sex: null,
    document_type: null,
    document_number: '',
    phone_number: '',
    phone_number_ref: '',
    current_address: '',
    ref_address: '',
    document_address: '',
    academic_level: '',
    titles_obtained: '',
    date_birth: dateLibs.today(),
    work_start_date: dateLibs.today(),
    trusted_person: false,
    state_id: null,
    city_id: null,
    district_id: null,
    concubine_type: 0,
    has_children: false,
    produccion: 0,
    adicional: 0,
    reintegro: 0,
    responsabilidad: 0,
    asistencia: 0,
    is_active: true,
    concubine: initConcubine,
    devices: [],
    assignment: {
        cost_center_id: null,
        position_id: null,
        headquarter_id: null,
        area_id: null,
        sub_area_id: null,
        work_shift_id: null,
        work_category: null,
        work_type: null,
        type_of_contract: 4,
        condition: 1,
        lunch: false,
        lunch_rate_id: null,
        contrato_number: '',
        labor_regime: 1,
        fixed_dialing: false
    },
    finance: {
        bank: '',
        telecredito: 0,
        tipo_cuenta: 0,
        moneda: 0,
        account_number: '',
        family_allowance: null,
        regular_bonus: null,
        base_salary: null,
        payment_frequency: 'biweekly',
        regular_amount: null,
        ordinary_perks: null,
        bank_cts: '',
        account_number_cts: ''
    },
    insurance: {
        afp_id: null,
        insurance_company_id: null,
        life_insurance: false,
        rent: false,
        right_environment: false,
        agricultural_insurance: false,
        regular_insurance: false,
        sctr_life: false,
        eps: false,
        type_regime: 1,
        cussp: '',
        sctr_pension: false,
        sctr_pension_description: null,
        date_afp: null,
        type_of_commission: null,
        gratification: false,
        sctr_health: false
    },
    children: []
}

const optionsStatusEmployee: PropOptionRadio[] = [
    {
        text: 'ACTIVO',
        value: true
    },
    {
        text: 'EN CESE',
        value: false
    }
]

export {
    employeeInitConst,
    optionsStatusEmployee
}
